import React from 'react';

import { NBHYPHEN } from '@r1-frontend/ui-react/tokens/symbols';

import BaseErrorToast from './BaseErrorToast';

const MovixNotSelected = ({ ...props }) => <BaseErrorToast {...props}>
    <>
        Вы&nbsp;не&nbsp;выбрали ТВ{NBHYPHEN}приставку Movix. Приставка нужна, чтобы смотреть ТВ{NBHYPHEN}каналы и&nbsp;подписки, если у&nbsp;вас нет Smart&nbsp;TV.
    </>
</BaseErrorToast>;

export default MovixNotSelected;
